import { Td, Tr, Typography } from '@aloft/toolkit-sui';

export const AsIsRow = () => (
  <Tr>
    <Td>
      <Typography variant="body1">“As-Is” Value of Site Improvements</Typography>
    </Td>
    <Td colSpan={8} className="cost-approach-table-align-right">
      Included in site value
    </Td>
  </Tr>
);
